import React from 'react';

import useStyles from './SignupIntroText.style';

const SignupIntroText: React.FC = () => {
  const { classes } = useStyles();

  return (
    <>
      <h2 className={classes.headline}>
        Your platform for listing faster and earning more
      </h2>

      <div className={classes.callout}>
        <h3 className={classes.h3}>
          Get quotes, instantly
        </h3>

        <p>
          See recommended services for any listing in seconds. Easily share with sellers for approval and payment.
        </p>
      </div>

      <div className={classes.callout}>
        <h3 className={classes.h3}>
          Keep listings on track
        </h3>

        <p>
          Manage all your prep work in one place. View progress, get updates and reschedule anytime.
        </p>
      </div>

      <div className={classes.callout}>
        <h3 className={classes.h3}>
          Help when you need it
        </h3>

        <p>
          Find answers quickly or contact our team for real-time support when questions pop up.
        </p>
      </div>
    </>
  );
};

export default SignupIntroText;
